import React from 'react';

export const Line = () => {
  return (<div className="relative w-[920px] h-[1.8px] bg-lightgray" />);
};
